import { Button, styled, Typography } from "@mui/material";
import { Field, Form, Formik } from "formik";
import { useTranslation } from "react-i18next";

import { useLayerValidation } from "hooks/layerHooks";
import { LayerFormValues } from "types/types";
import { FormikTextField } from "components/form/FormikTextField";

interface Props {
  initialValues: LayerFormValues;
  isEditing?: boolean;
  setIsDialogOpen: (isOpen: boolean) => void;
  onSubmit: (values: LayerFormValues) => void;
  onDelete?: () => void;
}

export function LayerForm(props: Props) {
  const {
    initialValues,
    isEditing = false,
    onSubmit,
    onDelete,
    setIsDialogOpen,
  } = props;
  const validationSchema = useLayerValidation();
  const { t } = useTranslation();

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={initialValues}
      validationSchema={validationSchema}
    >
      {() => (
        <StyledForm>
          <Typography>{t("label.toBeAddedMapHasToBeWMSProtocol")}</Typography>
          <Field
            component={FormikTextField}
            name="name"
            type="text"
            label={`${t("label.mapName")}:`}
          />
          <Typography>
            {t("label.WMSInfoFoundInTheGetCapabilitiesDocumentOfCurrentWMS")}
          </Typography>
          <Field
            component={FormikTextField}
            name="url"
            type="text"
            label={`${t("label.wmsUrl")}:`}
          />
          <Field
            component={FormikTextField}
            name="layerName"
            type="text"
            label={`${t("label.wmsLayerName")}:`}
          />
          <Field
            component={FormikTextField}
            name="legendUrl"
            type="text"
            label={`${t("label.urlGetLegendRequest")}:`}
          />
          <div className="action-buttons">
            {isEditing && (
              <Button color="error" onClick={onDelete}>
                {t("label.delete")}
              </Button>
            )}
            <Button onClick={() => setIsDialogOpen(false)}>
              {t("label.cancel")}
            </Button>
            <Button type="submit" variant="contained">
              {!isEditing && t("label.add")}
              {isEditing && t("label.save")}
            </Button>
          </div>
        </StyledForm>
      )}
    </Formik>
  );
}

const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  max-width: ${({ theme }) => theme.spacing(90)};
  gap: ${({ theme }) => theme.spacing(1)};
  .action-buttons {
    display: flex;
    justify-content: end;
    gap: ${({ theme }) => theme.spacing(1)};
  }
`;
